import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import FormSectionTitle from '../../../../components/FormSectionTitle';
import Button from '../../../../components/formControls/Button';
import {
  getEnterpriseInfo,
  getEnterpriseWelcomeMessage,
  getVirtualOperatorMessages,
  isEnterpriseWelcomeMessageSaveError,
  isEnterpriseWelcomeMessageSaveLoaded,
  isSaveEnterpriseInfoError,
  isSaveEnterpriseInfoLoaded,
  virtualOperatorMessagesLoaded,
} from '../../../../js/virtualOperator/selectors';
import { hasGrants } from '../../../../js/me/selectors';
import { saveEnterpriseInfoRequest, saveEnterpriseMessageRequest } from '../../../../js/virtualOperator/actions';
import ToastMessage from '../../../../components/messages/ToastMessage';
import { Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Select2 from '../../../../components/formControls/Select2';
import Loading from '../../../../components/Loading';

const messages = defineMessages({
  title: {
    id: 'PbxVirtualOperatorCustomerWelcome.title',
    defaultMessage: 'Welcome message',
  },
  welcomeMessageName: {
    id: 'PbxVirtualOperatorCustomerWelcome.welcomeMessageName',
    defaultMessage: 'Name',
  },
  welcomeMessageContent: {
    id: 'PbxVirtualOperatorCustomerWelcome.welcomeMessageContent',
    defaultMessage: 'Content',
  },
  noMessage: {
    id: 'PbxVirtualOperatorCustomerWelcome.noMessage',
    defaultMessage: 'No message',
  },
  buttonEdit: {
    id: 'PbxVirtualOperatorCustomerWelcome.buttonEdit',
    defaultMessage: 'Edit',
  },
  welcomeMessageModalTitle: {
    id: 'PbxVirtualOperatorCustomerWelcome.welcomeMessageModalTitle',
    defaultMessage: 'Edit welcome message',
  },
  buttonSave: {
    id: 'PbxVirtualOperatorCustomerWelcome.buttonSave',
    defaultMessage: 'Save',
  },
  buttonCancel: {
    id: 'PbxVirtualOperatorCustomerWelcome.buttonCancel',
    defaultMessage: 'Cancel',
  },
  saveError: {
    id: 'PbxVirtualOperatorCustomerWelcome.saveError',
    defaultMessage: 'Error saving welcome message',
  },
  message: {
    id: 'PbxVirtualOperatorCustomerWelcome.message',
    defaultMessage: 'Message',
  },
});

class PbxVirtualOperatorCustomerWelcome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalEditOpen: false,
      message: undefined
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.saveLoaded && !prevProps.saveLoaded && !this.props.saveError) {
      this.setState({
        modalEditOpen: false,
      });
    }
  }

  arrangeSelectedMessage = () => {
    if (this.state.message !== undefined) {
      return {
        value: this.state.message,
        label: this.state.message ? this.props.createdMessages.find(
          (message) => message.id === this.state.message
        ).name : '',
      }
    } else {
      return {
        value: this.props.welcomeMessage,
        label: this.props.welcomeMessage ? this.props.createdMessages.find(
          (message) => message.id === this.props.welcomeMessage
        ).name : '',
      }
    }
  }
      
  handleInfoChange = (event) => {
    this.setState({
      info: event.target.value,
    });
  };

  handleMessageSelection = (selectedOption) => {
    this.setState({
      message: selectedOption.value,
    });
  }

  save = () => {
    this.props.saveMessage({
      message: this.arrangeSelectedMessage().value,
    });
  };

  render() {
    const {
      canEdit,
      saveError,
      saveLoaded,
      intl: { formatMessage },
      welcomeMessage,
      messagesLoaded,
      createdMessages,
    } = this.props;
    const messagesOptions = [
      {
        value: null,
        label: '',
      },
    ];
    createdMessages.forEach((message) => {
      messagesOptions.push({
        value: message.id,
        label: message.name,
      });
    });
    const chosenMessage = welcomeMessage
      ? createdMessages.find((message) => message.id === welcomeMessage)
      : null;
    return (
      <>
        <div>
          <FormSectionTitle className="mt-3 mb-3">
            {formatMessage(messages.title)}
          </FormSectionTitle>
          {!messagesLoaded ? <Loading /> : (
            <React.Fragment>
              {chosenMessage ? (
                <React.Fragment>
                  <Label>
                    {formatMessage(messages.welcomeMessageName)}
                  </Label>
                  <span className='ml-3'>{chosenMessage.name}</span>
                  <br />
                  <Label>
                    {formatMessage(messages.welcomeMessageContent)}
                  </Label>
                  <span className='ml-3'>{chosenMessage.text}</span>
                </React.Fragment>
              ) : (
                <span>
                  {formatMessage(messages.noMessage)}
                </span>
              )}
              {canEdit &&  (
                <div className="pt-4 pb-4 text-center">
                  <Button
                    className="btn btn-primary"
                    text={formatMessage(messages.buttonEdit)}
                    onClick={() => this.setState({ modalEditOpen: true })}
                  />
                </div>
              )}
              {this.state.modalEditOpen && (
                <Modal isOpen={this.state.modalEditOpen}>
                  <ModalHeader toggle={() => this.setState({ modalEditOpen: false })}>
                    {formatMessage(messages.welcomeMessageModalTitle)}
                  </ModalHeader>
          
                  <ModalBody>
                    {saveError && (
                      <ToastMessage
                        type="danger"
                        text={formatMessage(messages.saveError)}
                        closeTimeout={5000}
                      />
                    )}
                    <div className="row">
                      <div className="col-xl-12 p-3">
                        <Label for="message">{formatMessage(messages.message)}</Label>
                        <Select2
                          id="message"
                          name="message"
                          options={messagesOptions}
                          isClearable
                          onChange={this.handleMessageSelection}
                          value={this.arrangeSelectedMessage()}
                        />
                      </div>
                    </div>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color="primary"
                      onClick={this.save}
                      text={formatMessage(messages.buttonSave)}
                      loading={!saveLoaded}
                    />
                    <button
                      type="button"
                      className="btn btn-outline-primary ml-2"
                      onClick={() => this.setState({ modalEditOpen: false })}
                    >
                      {formatMessage(messages.buttonCancel)}
                    </button>
                  </ModalFooter>
                </Modal>
              )}
            </React.Fragment>
          )}
          </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    welcomeMessage: getEnterpriseWelcomeMessage(state),
    saveLoaded: isEnterpriseWelcomeMessageSaveLoaded(state),
    saveError: isEnterpriseWelcomeMessageSaveError(state),
    canEdit: hasGrants(state, 'MANAGE_VIRTUAL_OPERATOR'),
    createdMessages: getVirtualOperatorMessages(state),
    messagesLoaded: virtualOperatorMessagesLoaded(state),
  };
}

export default injectIntl(
  connect(mapStateToProps, {
    saveMessage: saveEnterpriseMessageRequest,
  })(PbxVirtualOperatorCustomerWelcome)
);
